export default "__VITE_ASSET__fglATr3A__"